// Abu Dhabi locality copy for /ae/ac-service-abu-dhabi/locality/<slug>.
// paragraphs[0] is the hero lead. Each entry is written for its own area.

const localities = {
    'al-reem-island': {
        paragraphs: [
            'AC cleaning, coil washing and repairs for Al Reem Island towers, with the price shown before you book.',
            'Reem is a high-rise island and many of its towers are on district cooling, so apartments have chilled-water fan coils above the ceiling rather than split units. Surrounded by water, the island stays humid, and the most common problem is a musty smell from mould on the coil and blower.',
            'Towers here usually need contractor details in advance - include your building name when you book.',
        ],
        homes: 'High-rise apartments, mostly district-cooled with concealed ducted fan coils.',
        watch: 'Musty smells at start-up and drips from ceiling diffusers in humid months.',
        defaultMount: 'Ducted',
    },
    'khalifa-city': {
        paragraphs: [
            'AC service for Khalifa City villas - cleaning, coil washing, gas and repairs for whole houses.',
            'Khalifa City is a large mainland villa district, and homes here commonly run six to ten units across bedrooms, majlis and service areas, with outdoor units on roofs and in yards. Being inland, it is hotter and dustier than the island, which shows up as clogged filters and sand on outdoor coils.',
            'For houses this size, booking every unit on one visit, or a yearly plan, keeps the per-unit cost low.',
        ],
        homes: 'Large detached villas with many wall splits and some ducted systems, outdoor units on roofs and in yards.',
        watch: 'Afternoon struggles on upper floors - dirty outdoor coils and tired capacitors.',
        defaultMount: 'Wall',
    },
    'al-raha-beach': {
        paragraphs: [
            'AC service for Al Raha Beach apartments and townhouses along the waterfront.',
            'Raha Beach\'s low and mid-rise waterfront buildings sit right on the water, and humid air makes mould and drain blockages the usual complaints. Many buildings are district-cooled; townhouses tend to have their own ducted systems.',
            'If your unit smells every time it starts, a coil chemical wash is the fix; a filter clean alone won\'t reach it.',
        ],
        homes: 'Waterfront apartments on district cooling and townhouses with ducted units.',
        watch: 'Mould on diffusers and slow-draining condensate lines.',
        defaultMount: 'Ducted',
    },
    'yas-island': {
        paragraphs: [
            'AC cleaning and repairs for Yas Island villas, townhouses and apartments.',
            'Yas is one of Abu Dhabi\'s newer residential areas, with villa and townhouse communities alongside apartment buildings. Most systems are still young, so the job is mainly regular cleaning - and clearing dust from nearby development out of filters and drains.',
            'Villas and townhouses usually have ducted units per floor; a yearly maintenance plan suits them well.',
        ],
        homes: 'Newer villas and townhouses with ducted systems, and apartment buildings with concealed units.',
        watch: 'Construction dust in filters and drain lines in the first years after handover.',
        defaultMount: 'Ducted',
    },
    'saadiyat-island': {
        paragraphs: [
            'AC service for Saadiyat Island villas and beachfront apartments, with upfront prices.',
            'Saadiyat\'s beachfront homes face salt-laden sea air, which corrodes outdoor condenser fins and copper joints faster than inland. A yearly outdoor-unit check and clean helps prevent the slow gas leaks that corrosion causes.',
            'Large villas here often have both ducted zones and wall splits; tell us the mix when you book.',
        ],
        homes: 'Beachfront villas and apartments with ducted and split units.',
        watch: 'Corrosion on outdoor units and gradual loss of cooling from slow leaks.',
        defaultMount: 'Ducted',
    },
    corniche: {
        paragraphs: [
            'AC service for Corniche apartments and offices, from routine cleaning to repairs.',
            'The Corniche mixes older apartment blocks with newer high-rises along the waterfront. Older buildings tend to have their own split units, often many years old; newer towers are more often district-cooled. Either way, the sea air keeps humidity high.',
            'In older flats, a cleaning plus a gas pressure check often restores cooling that has faded over several summers.',
        ],
        homes: 'Mix of older apartment blocks with wall splits and newer towers with concealed units.',
        watch: 'Faded cooling in older units and musty smells in humid months.',
        defaultMount: 'Wall',
    },
    'al-reef': {
        paragraphs: [
            'AC service for Al Reef villas and apartments near the airport, with fixed per-unit prices.',
            'Al Reef sits on the mainland near the desert edge, and its themed villa communities deal with a lot of wind-blown sand. Filters clog quickly in spring and outdoor units collect sand on their fins.',
            'Booking all the units in a villa together is the most cost-effective way to keep them clean.',
        ],
        homes: 'Themed villa and townhouse communities plus low-rise apartments, mostly split and ducted units.',
        watch: 'Sand on outdoor coils and fast-clogging filters after windy days.',
        defaultMount: 'Wall',
    },
    'mohammed-bin-zayed-city': {
        paragraphs: [
            'AC service for Mohammed Bin Zayed City villas and apartments - cleaning, coil washes, gas and repairs.',
            'MBZ City is a large mainland residential area with many family villas and mid-rise apartment blocks. Units here run long hours in high inland heat, and older villas often have a mix of original and replacement units.',
            'If some rooms cool well and others don\'t, it is usually the older units - a coil wash and gas check on those first is the cost-effective approach.',
        ],
        homes: 'Family villas with many wall splits, and mid-rise apartments.',
        watch: 'Older units losing cooling in peak summer; capacitor failures in the heat.',
        defaultMount: 'Wall',
    },
    'al-khalidiyah': {
        paragraphs: [
            'AC cleaning and repairs for Al Khalidiyah apartments, with upfront prices.',
            'Khalidiyah is an established central district with many older apartment buildings, typically fitted with wall-mounted splits. Units of that age benefit most from a thorough coil wash, and often from a gas check.',
            'Parking near older buildings can be tight; share any loading instructions when you book.',
        ],
        homes: 'Older mid-rise apartment buildings with wall-mounted split units.',
        watch: 'Weak cooling and dust build-up in long-serving units.',
        defaultMount: 'Wall',
    },
    'al-mushrif': {
        paragraphs: [
            'AC service for Al Mushrif villas and homes, from routine cleaning to repairs.',
            'Al Mushrif is a leafy, established villa area on the main island. Many homes have been extended over the years, with split units added room by room. Irrigated gardens raise humidity around ground-floor units.',
            'For these mixed systems, a whole-house cleaning visit is the simplest way to bring every unit up to standard.',
        ],
        homes: 'Established villas with a mix of wall splits and older ducted systems.',
        watch: 'Mould in ground-floor units near gardens; worn older units.',
        defaultMount: 'Wall',
    },
    'masdar-city': {
        paragraphs: [
            'AC service for Masdar City homes and offices, with upfront per-unit prices.',
            'Masdar City was designed around energy efficiency, with shaded streets and buildings built to reduce cooling loads. Its efficient systems still need clean coils and filters to work as designed - dirt is the quickest way to lose that efficiency.',
            'Tell us your building when you book; some properties have specific contractor procedures.',
        ],
        homes: 'Energy-efficient apartment and office buildings with concealed units.',
        watch: 'Efficiency loss from dirty filters and coils.',
        defaultMount: 'Ducted',
    },
}

export default localities
